import angular from 'angular'

import template from './vd-tab.html'

angular.module('vend.ui').directive('vdTab', function (elementService) {
  return {
    transclude: true,
    scope: {
      active: '=',
      link: '=',
      type: '@',
      value: '=',
    },
    require: '^vdTabs',
    template,
    link(scope, $element, attrs, vdTabs) {
      attrs.$addClass('vd-tab')

      const _setActiveTab = isActive => {
        if (isActive) {
          scope.setActive()
        }
      }

      /**
       * Passes the selected tab to the parent vdTabs controller.
       *
       * @method setActiveTab
       */
      scope.setActive = () => vdTabs.setActiveTab($element, scope.value)

      // Handles the active tab being changed dynamically
      scope.$watch('active', _setActiveTab)

      // Set initial active state
      _setActiveTab(scope.active)
    },
  }
})
